import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

/**
 * Chip pequeño que muestra el ID truncado de una entidad y lo copia al
 * portapapeles al hacer click. Sin restricción de rol — visible para todos.
 *
 * Uso: <CopyableId id={item.id} />
 */
export default function CopyableId({ id }) {
  const [copied, setCopied] = useState(false);

  if (!id) return null;

  const idStr = String(id);

  const copy = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(idStr).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }).catch(() => {});
    }
  };

  return (
    <span
      onClick={copy}
      title={`${idStr} — click para copiar`}
      data-testid={`copyable-id-${idStr.slice(0, 8)}`}
      className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-200 cursor-pointer font-mono select-none"
    >
      {idStr.slice(0, 8)}…
      {copied ? <Check className="w-3 h-3 text-green-400" /> : <Copy className="w-3 h-3" />}
    </span>
  );
}
